/* eslint-disable max-len */
import { LicenseType } from '../api/enumerations';

export const Constants = {
  openToAccreditation: 'aberto a credenciamento pelo Proto',
  visibleToProto: 'Permitir visualização do edital pelo credenciado',
  activateVisibility:
    ' Ao ativar, o edital ficará visível para os credenciados no Proto.',
  accreditationDocuments: 'Documentos para credenciamento',
  licenseTypesAccepted: 'Registro profissional aceito',
  defineDocuments:
    'Defina os documentos que o prestador de serviço deverá assinar ou aceitar ao solicitar credenciamento neste edital.',
  addDocumentToAccept: 'Adicionar documento para aceite',
  contractService: 'Contrato de Prestação de Serviço *',
  dragAndDropgFile: 'Clique para selecionar ou arraste o arquivo',
  allowedFormat: 'Formatos permitidos: PDF • Tamanho máximo: 10MB',
  signDocObs:
    'O prestador deverá baixar, assinar e anexar este documento para concluir o credenciamento.',
  acceptDocObs:
    'O prestador de serviço precisará ler e confirmar o aceite deste documento durante o credenciamento.',
  docName: 'Nome do documento',
  removeFromNotice: 'Remover do edital',
  editDoc: 'Editar documento',
  addDoc: 'Adicionar documento',
  saveDoc: 'Salvar alterações',
  cancel: 'Cancelar',
  onlyPdfAllowed: 'Apenas arquivos PDF são permitidos.',
  fileTooLarge: 'O arquivo deve ter no máximo 10MB.',
  removeContractTitle: 'Remover Contrato?',
  removeContractSubtitle:
    'Você precisará anexar um novo arquivo antes de criar o edital.',
  removeExtraTitle: 'Remover documento do edital?',
  removeLabel: 'Remover',
  removeDocumentLabel: 'Remover documento',
  removeExtraSubtitle:
    'O documento {{docName}} será removido. O prestador de serviço não precisará mais aceitar este documento no credenciamento.',
  duplicateDocName: 'Já existe um documento com este nome.',
  presentationVideoTitle: 'Vídeo de apresentação',
  presentationVideoHelp:
    'Esse vídeo aparece no topo da página do edital para as empresas que ainda não são credenciadas. Use um vídeo curto explicando o processo de credenciamento.',
  youtubeLinkLabel: 'Link do YouTube',
  saveVideo: 'salvar',
  editVideo: 'editar link',
  cancelVideoEdit: 'cancelar',
  removeVideo: 'remover vídeo',
  removeVideoConfirm: 'remover o vídeo de apresentação deste edital',
  videoSaved: 'Vídeo salvo com sucesso!',
  videoRemoved: 'Vídeo removido.',
  invalidYoutubeUrl:
    'Informe um link válido do YouTube (youtube.com/watch?v=... ou youtu.be/...).',
  noVideo: 'Nenhum vídeo foi adicionado',
  unsupportedVideoLink:
    'Não foi possível gerar a pré-visualização deste link, mas ele continua salvo e é exibido no edital.',
  presentationVideoFrameTitle: 'Vídeo de apresentação do edital',
  searchCompany: 'buscar empresa',
  clearSearch: 'limpar busca',
  noRequestsRegistered: 'Nenhum pedido cadastrado.',
  noRequestsFound: 'Nenhum pedido encontrado.',
  createNotice: 'Criar edital',
  confirmChanges: 'Confirmar alterações',
  awaitingProviderAdvance:
    'Aguardando o credenciado avançar para a formalização do contrato.',
  awaitingSignedContract:
    'Solicitação em formalização, aguardando o envio do contrato assinado pelo credenciado.',
  formalizationUnderReview:
    'Solicitação em formalização de contrato, verifique os documentos.',
  changeRequestSummaryTitle: 'Resumo da solicitação',
  changeRequestPoles: 'Polos adicionados:',
  changeRequestTypologyGroups: 'Grupos de tipologia adicionados:',
  changeRequestPoleSingular: 'polo',
  changeRequestPolePlural: 'polos',
  teamDocumentsTitle: 'Equipe credenciada:',
  teamDocumentsHint: 'Clique em uma pessoa para ver a documentação enviada.',
  teamCompanyResponsibleLabel: 'Responsável pela empresa',
  teamTechnicalResponsibleLabel: 'Responsável técnico',
  teamGroupSingular: 'Grupo',
  teamGroupPlural: 'Grupos',
  teamPoleSingular: 'Polo',
  teamPolePlural: 'Polos',
  teamApprovedAtLabel: 'aprovado em',
  teamRequestedAtLabel: 'enviado em',
  teamRemovalRequestedAtLabel: 'descredenciamento solicitado em',
  teamAbsenceRangeLabel: 'de {start} a {end}',
  teamPendingRequestLabel: 'pedido pendente de análise',
  teamCounterApprovedSingular: 'aprovado',
  teamCounterApprovedPlural: 'aprovados',
  teamCounterInAnalysis: 'em análise',
  teamCounterPausedSingular: 'pausado',
  teamCounterPausedPlural: 'pausados',
  teamCounterLeaving: 'saindo',
  teamStatusApproved: 'Aprovado',
  teamStatusInAnalysis: 'Em análise',
  teamStatusPaused: 'Pausado',
  teamStatusLeaving: 'Saindo',
  teamTermUnderReviewTooltip:
    'Termo enviado e aguardando análise. A aprovação é feita na aba Administrativo.',
  teamTermAwaitingSignatureTooltip:
    'Aguardando o responsável da empresa assinar e enviar o termo.',
  accreditingForLabel: 'Credenciando para:',
  requiredDocumentationTitle: 'Documentação necessária:',
  tabLegalAnalysis: 'Análise Jurídica',
  tabEngineeringAnalysis: 'Análise Engenharia',
  tabAdministrative: 'Administrativo',
  legalAnalysisSection: 'Análise jurídica',
  legalPersonAnalysisSection: 'Análise técnica da Pessoa Jurídica',
  professionalAnalysisSection: 'Análise técnica do profissional',
  professionalQualificationSection:
    'Documentos de qualificação e habilitação profissional',
  extraDocumentsSection: 'Documentos adicionais',
  contractSection: 'Contrato de prestação de serviço',
  newDocumentButton: '+ novo documento',
  approveDocumentSuccess: 'Documento aprovado!',
  approveAccreditationSuccess: 'Credenciamento aprovado com sucesso!',
  approveWithReservationSuccess: 'Documento aprovado com ressalvas!',
  replaceRequestedSuccess: 'Substituição solicitada!',
  rejectDocumentSuccess: 'Documento rejeitado!',
  cancelDocumentSuccess: 'Documento cancelado!',
  genericError: 'Algo deu errado, tente novamente.',
  documentNotSentStatus: 'não enviado',
  otherDocumentsSection: 'Outros documentos de engenharia',
  criteriaHeader: 'Critério ({group} · {activity}): {description}',
  criteriaPendingRequest: 'grupo em análise',
  memberNoEngineeringDocuments:
    'Nenhum documento de engenharia enviado por esta pessoa.',
  memberDocumentsLoadError:
    'Não foi possível carregar os documentos. Feche e abra novamente.',
  teamLoadError:
    'Não foi possível carregar a equipe credenciada. Recarregue a página.',
  memberRequestsLoadError:
    'Não foi possível carregar as solicitações desta pessoa. Feche e abra novamente.',
  administrativeDocumentsSection: 'Documentos administrativos',
  additionTermLabel: 'Termo de Adição de Colaborador',
  dischargeTermLabel: 'Termo de Distrato',
  approveContractWarning:
    'Isso conclui o credenciamento da empresa e não pode ser desfeito por esta tela.',
  approveAdditionTermWarning:
    'Isso conclui o credenciamento individual deste profissional no edital.',
  approveDischargeTermWarning:
    'Isso descredencia este profissional do edital e não pode ser desfeito.',
  approveCompanyDischargeWarning:
    'Atenção: este é o distrato do responsável. Aprovar encerra o credenciamento da EMPRESA neste edital e descredencia todos os profissionais dela junto. Não pode ser desfeito.',
  administrativeDocumentOwner: 'de {owner}',
  scopeTermLabel: 'Termo Aditivo',
  scopeTermPoles: 'polos',
  scopeTermTypologyGroups: 'grupos de tipologia',
  approveScopeAdditionWarning:
    'Isso inclui os {items} do termo no credenciamento deste profissional. Onde não houver vaga, eles entram na fila de espera.',
  approveScopeRemovalWarning:
    'Isso remove os {items} do termo do credenciamento deste profissional e não pode ser desfeito.',
};

export const LICENSE_TYPE_OPTIONS: LicenseType[] = [
  LicenseType.CREA,
  LicenseType.CAU,
  LicenseType.CNAI,
];
